import { ABExperiments } from '@Common/hoc/ABTestWithFallbackCtrl';
import { RootState } from '@Common/models/redux/store';
import React from 'react';
import { useSelector } from 'react-redux';

export const useABTestValue = (experiment: string) => {
  const runningABTests = useSelector((state: RootState) => state.common.AbTestExperiments);
  // All AB tests info with fallback
  const ABTestData = useSelector((state: RootState) => state.common.AbTestExperimentsInfo);

  if (!ABTestData && !runningABTests) {
    return null;
  }

  let fallbackVariantFromABTest;
  if (!runningABTests?.[experiment]) {
    fallbackVariantFromABTest = ABTestData?.[experiment]?.fallBack;
  }

  return runningABTests?.[experiment] || fallbackVariantFromABTest || null;
};

export const withABTestHook = (experiment: ABExperiments) => {
  return function WrappedComponent(Component: any) {
    return function InnerComponent(props: any) {
      const abTest = useABTestValue(experiment);
      return <Component {...props} abTestData={{ [experiment]: abTest }} />;
    };
  };
};
